import { assertString } from '@Utils/assert';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { normalizeItems } from '@Utils';
import MessageBroker from '@Services/MessageBroker';
import StructureEditorOptionsStorage from '@Services/AppDBStorage/Storages/StructureEditorOptionsStorage';

export const fetchRawStructureOptions = Logger.logAsync(function fetchRawStructureOptions(context) {
  assertString(context, 'context, probably "all" has to be used as parameter');

  return StructureEditorOptionsStorage.get(context).then((dataFromStorage) => {
    if (dataFromStorage) {
      return dataFromStorage;
    }

    return MessageBroker.send(RequestUrls.structureOptions, { context }, { cache: false }).then((result) => {
      StructureEditorOptionsStorage.set(context, result);

      return result;
    });
  });
});

export function checkedByPredefinedOptions(option, predefinedOptions) {
  const { name, value } = option;
  const result = predefinedOptions.find((item) => {
    return item.name === name && item.value === value;
  });

  return Boolean(result);
}

export function normalizeOptionSubOption(subOption, predefinedOptions) {
  const checked = checkedByPredefinedOptions(subOption, predefinedOptions);

  return {
    ...subOption,
    id: subOption.title,
    checked,
  };
}

export function getInputValueExtention(option, predefinedOptions) {
  const { type, name } = option;

  if (type !== 'input') {
    return {};
  }

  const predefined = predefinedOptions.find((item) => {
    return item.name === name;
  });

  if (!predefined) {
    return {};
  }

  return {
    inputValue: predefined.value,
  };
}

function generalOptionsNormalization(items, predefinedOptions, normalizeFn) {
  const normalizedOptions = items.map((item) => {
    return normalizeFn(item, predefinedOptions);
  });
  const { ids, items: resultItems } = normalizeItems(normalizedOptions);

  return {
    itemsIds: ids,
    items: resultItems,
  };
}

export function normalizeOption(option, predefinedOptions) {
  const { subOptions, title, ...other } = option;
  const checked = checkedByPredefinedOptions(option, predefinedOptions);

  const normalizedOption = {
    ...other,
    ...getInputValueExtention(option, predefinedOptions),
    id: title,
    title,
    checked,
  };

  if (!subOptions) {
    return normalizedOption;
  }

  const { itemsIds: subOptionsIds, items: resultSubOptions } = generalOptionsNormalization(
    subOptions,
    predefinedOptions,
    normalizeOptionSubOption
  );

  const isOneOfSubOptionChecked = Boolean(
    subOptionsIds.find((id) => {
      return resultSubOptions[id].checked;
    })
  );

  if (isOneOfSubOptionChecked) {
    normalizedOption.checked = true;
  } else {
    resultSubOptions[subOptionsIds[0]].checked = true;
  }

  return {
    ...normalizedOption,
    subOptionsIds,
    subOptions: resultSubOptions,
  };
}

export function normalizeGroup(group, predefinedOptions) {
  const { options, ...other } = group;

  const { itemsIds, items } = generalOptionsNormalization(options, predefinedOptions, normalizeOption);

  return {
    ...other,
    optionsIds: itemsIds,
    options: items,
  };
}

export function normalizeFetchStructureOptions(result, customPredefinedOptions) {
  const { context, groups, options } = result;
  const resultPredefinedOptions = customPredefinedOptions || options;
  const filteredGroups = groups.filter((item) => {
    // hide options Product, Any Role, Starting material, Reagent/Catalyst since requirements doesn't have it
    return item.id !== 'as';
  });

  const { itemsIds, items } = generalOptionsNormalization(filteredGroups, resultPredefinedOptions, normalizeGroup);

  return {
    context,
    groups: items,
    groupsIds: itemsIds,
  };
}
